// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Pf2YC","loaderSmal":"Loader_loaderSmal__S3fos","LoaderIcon":"Loader_LoaderIcon__nFCJc","rotate":"Loader_rotate__6mtGm"};